import React from 'react';

/**
 * En-tête de page institutionnel Entrea (aligné sur le portail membre).
 * @param {string} title
 * @param {string} [subtitle]
 * @param {React.ReactNode} [actions]
 */
export function EntreaPageHeader({ title, subtitle, actions }) {
  return (
    <div className="entrea-portal-panel">
      <div className="flex flex-col gap-2 px-3 py-3 sm:gap-3 sm:px-6 sm:py-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <h1 className="text-lg font-semibold tracking-tight text-entrea-ink sm:text-xl">{title}</h1>
          {subtitle ? (
            <p className="mt-1 hidden text-sm text-slate-600 md:block">{subtitle}</p>
          ) : null}
        </div>
        {actions ? (
          <div className="flex max-w-full flex-shrink-0 flex-wrap items-center gap-2 sm:gap-3">
            {actions}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default EntreaPageHeader;
